module.exports = "\n<button\n    (click)=\"login()\"\n    class = \"btn btn-primary\"> Login with Google \n  </button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.html
// module id = ./src/app/login/login.component.html
// module chunks = main